import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I purchase a vehicle?",
      answer: "Simply browse our inventory, select your desired vehicle, and click 'Inquire About This Vehicle'. Our team will guide you through the entire process including payment, documentation, and shipping."
    },
    {
      question: "Do you ship worldwide?",
      answer: "Yes! We ship to over 50 countries worldwide. Shipping costs vary by destination. Contact us with your location for a detailed quote."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept bank transfers (TT), letters of credit (L/C), and other secure payment methods. Full payment is required before shipping."
    },
    {
      question: "How long does shipping take?",
      answer: "Shipping time varies by destination. Typically 2-4 weeks for Asia, 4-6 weeks for Africa, Middle East, and Europe, and 6-8 weeks for South America and Oceania."
    },
    {
      question: "Are the vehicles inspected?",
      answer: "Yes, all vehicles undergo thorough inspection. We provide detailed inspection reports including photos and condition grades."
    },
    {
      question: "Can I get more photos of a specific vehicle?",
      answer: "Absolutely! Just send us an inquiry and we'll provide additional photos and videos of any vehicle you're interested in."
    },
    {
      question: "What is FOB price?",
      answer: "FOB (Free On Board) is the price of the vehicle at the port of loading in Japan. It includes the vehicle cost and local charges but excludes international shipping and destination fees."
    },
    {
      question: "Do you help with import procedures?",
      answer: "Yes, we provide all necessary export documentation. However, you'll need to arrange import clearance and registration in your country."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="relative py-20 bg-gray-50 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1511406361295-0a1ff814c0ce?w=1920&q=85"
          alt="Background"
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50/98 via-white/95 to-gray-100/98"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">Got questions? We've got answers</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Card key={index} className="overflow-hidden hover:shadow-md transition-shadow">
              <CardContent className="p-0">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full text-left p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-8">{faq.question}</span>
                  {openIndex === index ? (
                    <ChevronUp className="h-5 w-5 text-red-600 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="h-5 w-5 text-gray-400 flex-shrink-0" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6 text-gray-600">
                    {faq.answer}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a
            href="/contact"
            className="inline-flex items-center text-red-600 hover:text-red-700 font-semibold"
          >
            Contact our team →
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;